// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M4 1H20V23H4V1ZM10.9996 17.0002V19.0041H13.0035V17.0002H10.9996ZM15.9733 13.8278L12.0003 5.88184L8.02734 13.8278L12.0003 12.5862L15.9733 13.8278Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-mobile-navigation-filled')
export default class MobileNavigationFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'mobile-navigation-filled',
    }
  }
}
